export default __webpack_public_path__ + "static/media/balanceDanger.1b100707.png";